// Medii Eコンサル フロートバナー
//
// 対象ページ（TARGET_PATHS）にのみ JS でバナーを挿入する。
// ページ側の HTML 編集は不要のため、対象ページの追加・削除はこの配列の変更だけで済む。
//
// 挙動:
//   バナークリック → 外部ディスクレーマー（既存 .disclaimer-modal のスタイルを再利用）
//   → 「外部サイトへ移動する」で別タブ遷移し、元ページのモーダルは閉じる
//   → ×ボタンで閉じると 24時間 非表示（max-age 付き Cookie。期限切れはブラウザが自動処理）

const TARGET_PATHS = [
  // アリケイスTOP
  '/product/arikayce/',
  // 製品関連動画
  '/product/arikayce/movie/product/',
  '/product/arikayce/movie/product/product-01/',
  '/product/arikayce/movie/product/product-02/',
  '/product/arikayce/movie/product/product-03/',
  '/product/arikayce/movie/product/product-04/',
  // 君塚先生講演動画
  '/product/arikayce/movie/seminar/',
  '/product/arikayce/movie/seminar/seminar-01/',
  // Focus on Pts動画
  '/product/arikayce/movie/support/',
  '/product/arikayce/movie/support/support-01/',
  '/product/arikayce/movie/support/support-02/',
  '/product/arikayce/movie/support/support-03/',
  // NTM Expert Interview
  '/product/arikayce/ntminfo/ntmexpertinterview/',
];

// 遷移先 URL は後送のため未設定。決まり次第ここに設定する
const MEDII_URL = 'https://medii.jp/mac-consultant?utm_source=pmn_ownd_disease-lp_37_mac_spn_1';

const COOKIE_NAME = 'medii_banner_closed';
const COOKIE_MAX_AGE = 60 * 60 * 24; // 24時間

const BANNER_ID = 'js-medii-banner';
const MODAL_ID = 'js-medii-disclaimer';

const isSuppressed = () =>
  document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)')) !== null;

const saveClosed = () => {
  let cookie = `${COOKIE_NAME}=true; max-age=${COOKIE_MAX_AGE}; path=/; SameSite=Lax`;
  // Secure は HTTPS のときのみ付与（localhost の http で Cookie が保存されないのを防ぐ）
  if (location.protocol === 'https:') cookie += '; Secure';
  document.cookie = cookie;
};

export const initMediiBanner = () => {
  let path = location.pathname.replace(/index\.html$/, '');
  if (!path.endsWith('/')) path += '/';
  if (!TARGET_PATHS.includes(path)) return;
  if (isSuppressed()) return;

  // 画像は CSS 背景（_parts-medii-banner.scss）で指定する。
  // JS からの絶対パス（/assets/…）は WP 本番でテーマ配下のパスと食い違い 404 になるため、
  // CSS ファイル基準の相対パス（../img/…）で解決させる
  const bannerHTML = `
    <div class="medii-banner" id="${BANNER_ID}">
      <button class="banner" type="button" aria-label="Medii Eコンサル 肺MAC症関連コンテンツも掲載"></button>
      <button class="close" type="button" aria-label="バナーを閉じる"></button>
    </div>
  `;
  document.body.insertAdjacentHTML('beforeend', bannerHTML);
  const banner = document.getElementById(BANNER_ID);

  const lockScroll = () => {
    document.documentElement.style.overflow = 'hidden';
  };
  const unlockScroll = () => {
    document.documentElement.style.overflow = '';
  };

  // 外部ディスクレーマー。ページロード時の既存ディスクレーマー判定
  // （disclaimerModal.js）と干渉しないよう、初回クリック時に生成する
  let modal = null;
  const createModal = () => {
    if (modal) return;

    const modalHTML = `
      <dialog class="disclaimer-modal" id="${MODAL_ID}">
        <div class="inner">
          <div class="about">
            <h2 class="title">外部サイトへ移動します。</h2>
            <p class="txt -center_sp_left">Insmed naviをご覧いただきありがとうございます。<br>これより先の外部サイトの内容について、インスメッド合同会社は一切の責任を負いません。</p>
          </div>
          <div class="actions">
            <button class="consent-btn" type="button">外部サイトへ移動する</button>
            <button class="consent-btn -cancel" type="button">元のページに戻る</button>
          </div>
          <div class="logo -corporate" role="img" aria-label="insmed"></div>
        </div>
      </dialog>
    `;
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    modal = document.getElementById(MODAL_ID);

    // ESC で閉じた場合も含めてスクロールロックを解除する
    modal.addEventListener('close', unlockScroll);

    // バックドロップクリックで閉じる
    modal.addEventListener('click', (e) => {
      if (e.target === modal) modal.close();
    });

    // 同意 → 別タブで遷移し、元ページ側のモーダルは閉じる
    modal.querySelector('.consent-btn:not(.-cancel)').addEventListener('click', () => {
      if (MEDII_URL) window.open(MEDII_URL, '_blank', 'noopener');
      modal.close();
    });

    // 元のページに戻る
    modal.querySelector('.consent-btn.-cancel').addEventListener('click', () => {
      modal.close();
    });
  };

  // バナークリック → 外部ディスクレーマーを開く
  banner.querySelector('.banner').addEventListener('click', () => {
    createModal();
    modal.showModal();
    lockScroll();
  });

  // ×ボタン → バナーを閉じて 24時間 非表示
  banner.querySelector('.close').addEventListener('click', () => {
    saveClosed();
    banner.remove();
  });
};
